export const Th = {}

export default Th
